module.exports = __webpack_public_path__ + "static/img/ok.6c28d1e9.png";